import type { ImportQueueItem } from '../types/import-queue-item';

export type ImportTreeFolder = {
  kind: 'folder';
  name: string;
  depth: number;
  children: ImportTreeNode[];
};

export type ImportTreeFile = {
  kind: 'file';
  item: ImportQueueItem;
  depth: number;
};

export type ImportTreeNode = ImportTreeFolder | ImportTreeFile;

function getOrCreateFolder(
  children: ImportTreeNode[],
  name: string,
  depth: number
): ImportTreeFolder {
  const existing = children.find(
    (n): n is ImportTreeFolder => n.kind === 'folder' && n.name === name
  );
  if (existing) return existing;
  const folder: ImportTreeFolder = {
    kind: 'folder',
    name,
    depth,
    children: [],
  };
  children.push(folder);
  return folder;
}

export function buildImportTree(items: ImportQueueItem[]): ImportTreeNode[] {
  const roots: ImportTreeNode[] = [];

  for (const item of items) {
    const path = item.relativePath || item.fileName;
    const segments = path.split('/').filter(Boolean);
    const folderSegments = segments.slice(0, -1);

    if (folderSegments.length === 0) {
      roots.push({ kind: 'file', item, depth: 0 });
      continue;
    }

    let currentChildren = roots;
    let depth = 0;
    for (const segment of folderSegments) {
      const folder = getOrCreateFolder(currentChildren, segment, depth);
      currentChildren = folder.children;
      depth++;
    }
    currentChildren.push({ kind: 'file', item, depth });
  }

  return roots;
}
